module.exports = __webpack_public_path__ + "img/JAOC_POP_TomatoSauce_oval.cbc61cc7.png";